<template>
  <cost-reporter-beta :instance="instance" :token="token" :costReportQueryServer="costReportQueryServer" @failed="onFailed" @setModified="setModified" @clearModified="clearModified" @mounted="mou"/>
</template>

<script>
  import '@sigmacloud/sigma-vue-costreporting'
  export default {
    data () {
      return {
        instance: this.$store.getters.getActiveInstance.url,
        token: this.$store.getters.getActiveInstance.token,
        costReportQueryServer: this.$store.getters.getSigmaQueryUrl,
        isModified: false
      }
    },
    methods: {
      onFailed: event => {
        alert('there was an error, please refresh')
      },
      setModified () {
        this.isModified = true
      },
      clearModified () {
        this.isModified = false
      },
      mou (par) {
        console.log('Tst', par)
      }
    },
    beforeRouteLeave (to, from, next) {
      if (this.isModified && !this.$store.getters.getRouteLeaveConfirmation) {
        return this.$store.dispatch('setDestinationRoute', to)
        .then(() => this.$store.dispatch('changeModalVisibility', { entityType: 'changeLossModal', visible: true }))
        .catch(e => console.log(e))
      } else {
        next()
      }
    }
  }
</script>

<style>
  @import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
  @import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';
  @font-face {
    font-family: 'Icons';
    src: url('../../../node_modules/@sigmacloud/sigma-vue-costreporting/dist/fonts/open-iconic.eot');
    src: url('../../../node_modules/@sigmacloud/sigma-vue-costreporting/dist/fonts/open-iconic.eot?#iconic-sm') format('embedded-opentype'), url('../../../node_modules/@sigmacloud/sigma-vue-costreporting/dist/fonts/open-iconic.woff') format('woff'), url('../../../node_modules/@sigmacloud/sigma-vue-costreporting/dist/fonts/open-iconic.ttf') format('truetype'), url('../../../node_modules/@sigmacloud/sigma-vue-costreporting/dist/img/open-iconic.svg#iconic-sm') format('svg');
    font-weight: normal;
    font-style: normal;
  }
  cost-reporter-beta {
    width: 100%;
    background: #ffffff;
    font-family: "Helvetica", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/Programs/CostReporterBeta.vue